import styled, { keyframes } from "styled-components";

export const SkeletonRightFrame = () => {
	return (
		<Container>
			<SkeletonComponent />
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	justify-content: center;
	align-items: start;
`;

const shimmer = keyframes`
	0% {
		background-position: -200% 0;
	}
	100% {
		background-position: 200% 0;
	}
`;

const SkeletonComponent = styled.div`
	width: 90%;
	height: 60%;
	border-radius: 5px;
	margin-top: 20px;
	background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
	background-size: 200% 100%;
	animation: ${shimmer} 3s infinite linear;
`;
